import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n/LanguageContext";
import "./legal.css";

function CookiePolicy() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isNe = lang === "ne";

  const sections = isNe
    ? [
        { id: "cp-what", title: "१. कुकी के हो?", body: ["कुकी साना टेक्स्ट फाइलहरू हुन् जसले वेबसाइटलाई काम गर्न, प्राथमिकता सम्झन र सुरक्षा सुधार्न मद्दत गर्छ।"] },
        { id: "cp-types", title: "२. हामी प्रयोग गर्ने कुकीका प्रकार", body: ["मुख्य प्रकारहरू: Essential, Functional, Analytics, र Performance Cookies।"], list: ["Essential: लगइन र सेसन सुरक्षा", "Functional: भाषा/सेटिङ प्राथमिकता", "Analytics: प्रयोगको समग्र विश्लेषण", "Performance: त्रुटि र गति मापन"] },
        { id: "cp-why", title: "३. हामी कुकी किन प्रयोग गर्छौं", list: ["सुरक्षित लगइन कायम राख्न", "सत्र सुरक्षा र आक्रमण रोकथाम", "प्रयोगकर्ता अनुभव सुधार", "सेवाको समस्या पहिचान र समाधान"] },
        { id: "cp-third", title: "४. तेस्रो पक्ष कुकी", body: ["क्लाउड/CDN वा विश्लेषण प्रदायकले आफ्नै कुकी सेट गर्न सक्छन्। तिनको नीति तिनै पक्षले नियन्त्रण गर्छन्।"] },
        { id: "cp-controls", title: "५. कुकी प्राथमिकता व्यवस्थापन", body: ["ब्राउजर सेटिङबाट कुकी हेर्न, मेटाउन वा ब्लक गर्न सकिन्छ। आवश्यक कुकी बन्द गर्दा लगइन र मुख्य सुविधा काम नगर्न सक्छन्।"] },
        { id: "cp-dnt", title: "६. Do Not Track", body: ["DNT संकेत लागू कानुन र प्राविधिक सम्भाव्यता अनुसार विचार गरिन्छ। आवश्यक सुरक्षा कुकीहरू भने प्लेटफर्म सुरक्षाका लागि अनिवार्य हुन्छन्।"] },
        { id: "cp-changes", title: "७. नीति परिवर्तन", body: ["यो नीति समय-समयमा अद्यावधिक हुन सक्छ। महत्त्वपूर्ण परिवर्तन प्लेटफर्म सूचनाबाट जानकारी गराइन्छ।"] },
        { id: "cp-contact", title: "८. सम्पर्क", body: ["कुकी सम्बन्धी प्रश्नका लागि हामीलाई सम्पर्क गर्नुहोस्।"] },
      ]
    : [
        { id: "cp-what", title: "1. What Are Cookies", body: ["Cookies are small text files that help websites function, remember preferences, and support security."] },
        { id: "cp-types", title: "2. Types of Cookies We Use", body: ["We use Essential, Functional, Analytics, and Performance cookies."], list: ["Essential: login and session security", "Functional: language and preference memory", "Analytics: aggregated usage insights", "Performance: error and speed diagnostics"] },
        { id: "cp-why", title: "3. Why We Use Cookies", list: ["Keep users securely signed in", "Protect sessions and prevent attacks", "Improve usability", "Detect and fix platform issues"] },
        { id: "cp-third", title: "4. Third-Party Cookies", body: ["Cloud/CDN or analytics providers may set their own cookies under their own policies."] },
        { id: "cp-controls", title: "5. Managing Your Cookie Preferences", body: ["You can manage cookies in browser settings. Disabling essential cookies may break login and core platform features."] },
        { id: "cp-dnt", title: "6. Do Not Track", body: ["DNT signals are considered as required by applicable law and technical feasibility. Essential security cookies remain necessary."] },
        { id: "cp-changes", title: "7. Changes to this Policy", body: ["This policy may be updated periodically. Material updates are announced on the platform."] },
        { id: "cp-contact", title: "8. Contact", body: ["Contact us with any questions about cookie usage."] },
      ];

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <button className="legal-back-btn text-white opacity-75 mb-3" onClick={() => navigate(-1)}>
            {isNe ? "← फिर्ता" : "← Back"}
          </button>
          <h1>{isNe ? "कुकी नीति" : "Cookie Policy"}</h1>
          <p className="legal-meta mb-0">
            {isNe
              ? "प्रभावी मिति: जनवरी १, २०२५ · संस्करण १.० · प्लेटफर्म: GharBhada"
              : "Effective Date: January 1, 2025 · Version 1.0 · Platform: GharBhada"}
          </p>
        </div>
      </div>

      <div className="container">
        <div className="legal-card">
          <div className="legal-toc">
            <h6>{isNe ? "विषयसूची" : "Table of Contents"}</h6>
            <ol>
              {sections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>{section.title.replace(/^\d+\.\s*/, "")}</a>
                </li>
              ))}
            </ol>
          </div>

          <div className="legal-highlight">
            {isNe
              ? "यो नीति GharBhada मा कुकी र समान प्रविधि कसरी प्रयोग हुन्छ भनेर बताउँछ।"
              : "This policy explains how GharBhada uses cookies and similar technologies."}
          </div>

          {sections.map((section) => (
            <div className="legal-section" id={section.id} key={section.id}>
              <h2>{section.title}</h2>
              {section.body?.map((p) => (
                <p key={p}>{p}</p>
              ))}
              {section.list && (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div className="legal-contact-box">
            <h5>{isNe ? "GharBhada गोपनीयता टोली" : "GharBhada Privacy Team"}</h5>
            <p className="mb-1 small">
              Email: <a href="mailto:privacy@gharbhada.com">privacy@gharbhada.com</a>
            </p>
            <p className="mb-1 small">
              Support: <a href="mailto:support@gharbhada.com">support@gharbhada.com</a>
            </p>
            <p className="mb-0 small">Address: Kathmandu Valley, Nepal</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy;
